import { useQuery } from '@tanstack/react-query'
import { MasterApi } from '@ulysses-inc/harami_api_client'
import { baseClient } from 'src/state/middleware/saga/baseClient'
import { localeAwareSort } from 'src/util/sortStringsLocaleAware'
import { queryKeys } from './queryKeys'

export const masterTemplatesQueryFn = (masterUuid: string) =>
  baseClient.getApi(MasterApi).getMasterTemplates({ masterUuid })

export const useQueryMasterTemplates = (
  masterUuid: string,
  enabled: boolean,
) => {
  return useQuery({
    queryKey: queryKeys.masterTemplates(masterUuid),
    queryFn: () => masterTemplatesQueryFn(masterUuid),
    enabled: enabled && !!masterUuid,
    select: data => ({
      ...data,
      templates: [...data.templates].sort((a, b) =>
        localeAwareSort(a.name, b.name),
      ),
    }),
  })
}
